import { React, useEffect, useState, useRef } from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';
import Fab from '@mui/material/Fab';
import IconButton from '@mui/material/IconButton';
import { useSnackbar } from 'notistack';
import TokenService from '../../services/TokenService'
import Avatar from '@mui/material/Avatar';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import VerifyPhoneNumber from '../Modals/VerifyPhoneNumber';
import SaveIcon from '@mui/icons-material/Save';

import AddAPhotoIcon from '@mui/icons-material/AddAPhoto';
import DoneIcon from '@mui/icons-material/Done';
import SentimentVerySatisfiedIcon from '@mui/icons-material/SentimentVerySatisfied';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import CheckIcon from '@mui/icons-material/Check';
import EditIcon from '@mui/icons-material/Edit';
import DoDisturbIcon from '@mui/icons-material/DoDisturb';
import GppBadIcon from '@mui/icons-material/GppBad';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import ContactEmergencyIcon from '@mui/icons-material/ContactEmergency';
import HourglassTopIcon from '@mui/icons-material/HourglassTop';
import EXIF from 'exif-js';



function Profile(props) {
   
    const [isEdittingMyAccountProfile, setIsEdittingMyAccountProfile] = useState(false);

    const [profilePic, setProfilePic] = useState(props.loggedInUser == null ? '' : props.loggedInUser.ReturnerPhoto);
    const [firstName, setFirstName] = useState(props.loggedInUser == null ? '' : props.loggedInUser.FirstName);
    const [lastName, setLastName] = useState(props.loggedInUser == null ? '' : props.loggedInUser.LastName);
    const [phoneNumber, setPhoneNumber] = useState(props.loggedInUser == null ? '' : normalizePhoneNumber(props.loggedInUser.PhoneNumber));
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [isVerifyingPhoneNumber, setIsVerifyingPhoneNumber] = useState(false);
    const photoGps = useRef(null);

    const [formValidation, setFormValidation] = useState({
        isValid: false,
        errors: []
    });

    useEffect(() => {
        if (props.loggedInUser !== null && props.loggedInUser !== undefined) {
            setFirstName(props.loggedInUser.FirstName);
            setLastName(props.loggedInUser.LastName);
            setPhoneNumber(props.loggedInUser.PhoneNumber);
            setProfilePic(props.loggedInUser.ReturnerPhoto);
        } 
    }, [props]);

    function validate() {

        let isValid = true;
        let errors = [];

        if (firstName.trim() == '') {
            errors["Firstname"] = "Missing your First Name";
            isValid = false;
        }

        if (lastName.trim() == '') {
            errors["Lastname"] = "Missing your Last Name";
            isValid = false;
        }

        if (phoneNumber.trim() === '') {
            errors["PhoneNumber"] = "Please enter your phone number";
            isValid = false;
        }
        else {
            if (phoneNumber.trim().length === 14 || phoneNumber.trim().length === 10) {
                // valid
            }
            else {
                errors["PhoneNumber"] = "Enter your 10 digit phone number";
                isValid = false;
            }
        }

       

        setFormValidation({
            isValid: isValid,
            errors: errors
        });

        return {
            isValid: isValid,
            errors: errors
        }
    }

    function setIsEditting(isEditing) {
        if (props.loggedInUser !== null) {
            setFirstName(props.loggedInUser.FirstName);
            setLastName(props.loggedInUser.LastName);
            setPhoneNumber(normalizePhoneNumber(props.loggedInUser.PhoneNumber));
            setProfilePic(props.loggedInUser.ReturnerPhoto);
        } 
        setIsEdittingMyAccountProfile(isEditing);
    }

    function setPhoneNumberChanged(val) {
        let phone = normalizePhoneNumber(val);
        setPhoneNumber(phone);
    }

    function handleShowVerifyPhoneNumber() {
        setIsVerifyingPhoneNumber(true);
    }

    function normalizePhoneNumber(value, previousValue) {
        if (!value) return value;
        const currentValue = value.replace(/[^\d]/g, '');
        const cvLength = currentValue.length;

        //if (!previousValue)// || value.length > previousValue.length)
        {
            if (cvLength < 4) return currentValue;
            if (cvLength < 7) return `(${currentValue.slice(0, 3)}) ${currentValue.slice(3)}`;
            return `(${currentValue.slice(0, 3)}) ${currentValue.slice(3, 6)}-${currentValue.slice(6, 10)}`;
        }
    };

    function buildReadOnlyPhoneNumber() {
        let check = null;
        if (props.loggedInUser.IsPhoneNumberVerified) {
            check = <VerifiedUserIcon sx={{ color: 'var(--sipzee-green)', fontSize: 30, marginLeft: '10px' }} />
        }
        else {
            check = <Fab style={{ marginLeft: '10px' }} onClick={handleShowVerifyPhoneNumber }>
                <GppBadIcon sx={{ color: 'var(--sipzee-red)', fontSize: 30 }} />
            </Fab>
        }
           

        return (
            <div style={{ marginRight: 'auto', marginLeft: 'auto', alignSelf: 'center', display: 'flex' }}>
                <div style={{ alignSelf: 'center' }}>{normalizePhoneNumber(props.loggedInUser.PhoneNumber)}</div>
                {check}
            </div>
        );
    }

    function handleSaveProfile() {
        //MyAccountInfo_Update	
        if (validate().isValid) {
            let postData = {
                firstName: firstName,
                lastName: lastName,
                phoneNumber: phoneNumber
            }

            TokenService.post(postData, 'MyAccountInfo_Update')
                .then((response) => {
                    response = response[Object.keys(response)[0]];
                    if (response.Result == "SUCCESS") {
                        //props.loggedInUser = response;
                        props.onChange(response);
                        setIsEdittingMyAccountProfile(false);

                        let jsonData = JSON.parse(response.JsonData);
                        let level = JSON.parse(jsonData.ReturnerLevel);
                        let event = new CustomEvent('ReturnerLevel_Updated', {
                            detail: level
                        });
                        document.getElementsByTagName('body')[0].dispatchEvent(event);
                    }
                    else {
                        enqueueSnackbar(response.Message, {
                            variant: 'error',
                        });
                    }
                })
                .catch((response) => {
                    enqueueSnackbar('Oops, something went wrong', {
                        variant: 'error',
                    });
                });
        }
    }

    function handleVerifyClosed(isVerified) {

        setIsVerifyingPhoneNumber(false);

        if (isVerified) {
            props.loggedInUser.IsPhoneNumberVerified = true;
            props.onChange(props.loggedInUser);
        }
    }

    function handleUploadImageClick(event, imageType) {
        let file = event.target.files[0];
       


            //photoGps.current = { latitude, longitude };
            const reader = new FileReader();
            var url = reader.readAsDataURL(file);
            reader.onloadend = function (e) {


                EXIF.getData(file, function () {
                    let latitude = EXIF.getTag(this, "GPSLatitude");
                    let longitude = EXIF.getTag(this, "GPSLongitude");

                    if (latitude == undefined) {
                        latitude = 0;
                        longitude = 0;
                        var postData = {
                            data: reader.result,
                            dataType: imageType == 'Profile' ? 'Profile Photo' : 'Photo ID'
                        }
                        TokenService.post(postData, 'Returner_AssociatePhotoData');
                    }
                    else {
                        let exifLongRef = EXIF.getTag(this, "GPSLongitudeRef");
                        let exifLatRef = EXIF.getTag(this, "GPSLatitudeRef");
                        latitude = latitude[0] + (latitude[1] / 60) + (latitude[2] / (60 * 60))
                        longitude = longitude[0] + (longitude[1] / 60) + (longitude[2] / (60 * 60))
                        if (exifLatRef == "S") {
                            latitude *= 1;
                        }
                        if (exifLongRef == "W") {
                            longitude *= -1;
                        }
                        var postData = {
                            data: JSON.stringify({ latitude, longitude }),
                            dataType: imageType == 'Profile' ? 'Profile Photo' : 'Photo ID'
                        }
                        TokenService.post(postData, 'Returner_AssociateData');
                    }
                })

                // resize the imagage
                var img = document.createElement("img");
                img.onload = function (event) {
                    var MAX_WIDTH = 1024;
                    var MAX_HEIGHT = 1024;

                    var width = img.width;
                    var height = img.height;

                    // Change the resizing logic
                    if (width > height) {
                        if (width > MAX_WIDTH) {
                            height = height * (MAX_WIDTH / width);
                            width = MAX_WIDTH;
                        }
                    } else {
                        if (height > MAX_HEIGHT) {
                            width = width * (MAX_HEIGHT / height);
                            height = MAX_HEIGHT;
                        }
                    }
                    var canvas = document.createElement("canvas");
                    canvas.width = width;
                    canvas.height = height;
                    var ctx = canvas.getContext("2d");
                    // Actual resizing
                    ctx.drawImage(img, 0, 0, width, height);



                    // Show resized image in preview element
                    var dataurl = canvas.toDataURL(file.type);
                    //document.getElementById("preview").src = dataurl;

                    //if (photoGps.current == null) {
                    //    photoGps.current = { latitude: 0, longitude: 0 }
                    //}


                    let postData = {
                        photoData: dataurl
                        //meta: JSON.stringify(photoGps.current) 
                    }

                    if (imageType == 'Profile') {
                        setProfilePic(dataurl);
                        TokenService.post(postData, 'UpdateReturnerProfilePhoto')
                            .then((response) => {
                                response = response[Object.keys(response)[0]];
                                if (response.Result == "SUCCESS") {
                                    let jsonData = JSON.parse(response.JsonData);

                                    let returner = JSON.parse(jsonData.LoggedInUser);
                                    props.onChange(returner);
                                    setIsEdittingMyAccountProfile(false);
                                    let level = JSON.parse(jsonData.ReturnerLevel);
                                    let event = new CustomEvent('ReturnerLevel_Updated', {
                                        detail: level
                                    });
                                    document.getElementsByTagName('body')[0].dispatchEvent(event);
                                }
                            })
                            .catch((response) => {
                                enqueueSnackbar('Oops, something went wrong', {
                                    variant: 'error',
                                });
                            });
                    }
                    else if (imageType = 'PhotoId') {
                        TokenService.post(postData, 'UpdateReturnerPhotoId')
                            .then((response) => {
                                response = response[Object.keys(response)[0]];
                                if (response.Result == "SUCCESS") {
                                    let jsonData = JSON.parse(response.JsonData);

                                    let returner = JSON.parse(jsonData.LoggedInUser);
                                    props.onChange(returner);

                                    let level = JSON.parse(jsonData.ReturnerLevel);
                                    let event = new CustomEvent('ReturnerLevel_Updated', {
                                        detail: level
                                    });
                                    document.getElementsByTagName('body')[0].dispatchEvent(event);
                                }
                            })
                            .catch((response) => {
                                enqueueSnackbar('Oops, something went wrong', {
                                    variant: 'error',
                                });
                            });
                    }


                }
                img.src = reader.result;


            }.bind(this);

     

       
    };

    function buildSkeleton() {
        return <Stack spacing={0}>
            <Skeleton variant="circular" width={100} height={100} style={{ alignSelf: 'center' }} />
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <Skeleton variant="circular" width={25} height={25} style={{ alignSelf: 'center' }} />
                <Skeleton variant="text" sx={{ fontSize: '2rem', marginRight: 'auto', marginLeft: 'auto' }} width={210} />
            </div>

            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <Skeleton variant="circular" width={25} height={25} style={{ alignSelf: 'center' }} />
                <Skeleton variant="text" sx={{ fontSize: '2rem', marginRight: 'auto', marginLeft: 'auto' }} width={210} />
            </div>

            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <Skeleton variant="circular" width={25} height={25} style={{ alignSelf: 'center' }} />
                <Skeleton variant="text" sx={{ fontSize: '2rem', marginRight: 'auto', marginLeft: 'auto' }} width={210} />
            </div>

            <Skeleton variant="rectangular" width={'100%'} height={2} />

            <Skeleton variant="text" sx={{ fontSize: '2rem', marginRight: 'auto', marginLeft: 'auto' }} width={210} />

            <div style={{ display: 'flex', justifyContent: 'center' }}>
                <Skeleton variant="circular" width={25} height={25} style={{ alignSelf: 'center', marginRight: '30px' }} />
                <Skeleton variant="circular" width={25} height={25} style={{ alignSelf: 'center' }} />
                <Skeleton variant="circular" width={25} height={25} style={{ alignSelf: 'center', marginLeft: '30px' }} />
            </div>

            <Skeleton variant="rectangular" width={'100%'} height={2} style={{ marginTop: '5px' }} />

            <Skeleton variant="text" sx={{ fontSize: '2rem', marginRight: 'auto', marginLeft: 'auto' }} width={210} />

            <div style={{ display: 'flex', justifyContent: 'center' }}>
                <Skeleton variant="circular" width={25} height={25} style={{ alignSelf: 'center', marginRight: '30px' }} />
                <Skeleton variant="circular" width={25} height={25} style={{ alignSelf: 'center', marginLeft: '30px' }} />
            </div>

        </Stack>
    }

    function buildContent() {
        return <Stack spacing={1}>
            <Avatar
                alt="Photo"
                src={profilePic}
                sx={{ width: 100, height: 100, alignSelf: 'center' }}
            />
            <div style={{ marginTop: '-20px' }}>
                <IconButton aria-label="More Info" onClick={() => props.showMoreInfo('Photo')} tabIndex={-1} style={{ marginRight: '20px' }}>
                    <HelpOutlineIcon sx={{ color: 'var(--sipzee-yellow)', fontSize: 40 }} />
                </IconButton>
                <IconButton variant="contained" component="label">
                    <AddAPhotoIcon sx={{ fontSize: 40 }} />
                    <input hidden accept="image/*" type="file" onChange={(e) => handleUploadImageClick(e, 'Profile')} />
                </IconButton>
            </div>
            <div style={{ display: 'flex', justifyContent: 'flex-start' }}>
                <AccountCircleIcon sx={{ color: 'var(--sipzee-green)', fontSize: 30 , marginTop:'5px'}} />
                {isEdittingMyAccountProfile ?
                    <div style={{marginLeft:'10px'} }>
                        <div>
                            <TextField error={formValidation.errors['Firstname'] !== undefined} label="First Name" onChange={(e) => setFirstName(e.target.value)} value={firstName} variant="outlined" style={{maxWidth:'270px'}} />
                            <div className='FormFieldErrorDescription' style={{ textAlign: 'left' }}> {formValidation.errors['Firstname'] !== undefined ? formValidation.errors['Firstname'] : ''}</div>
                        </div>
                        <div style={{ marginTop: '7px' }}>
                            <TextField error={formValidation.errors['Lastname'] !== undefined} label="Last Name" onChange={(e) => setLastName(e.target.value)} value={lastName} variant="outlined" style={{ maxWidth: '270px' }} />
                            <div className='FormFieldErrorDescription' style={{ textAlign: 'left' }}> {formValidation.errors['Lastname'] !== undefined ? formValidation.errors['Lastname'] : ''}</div>
                        </div>
                    </div>
                    :
                    <div style={{ marginRight: 'auto', marginLeft: 'auto', fontWeight: 'bold', fontSize: '14pt', alignSelf: 'center' }}>{props.loggedInUser.FirstName} {props.loggedInUser.LastName}</div>
                }
            </div>
            <div style={{ display: 'flex', justifyContent: 'flex-start' }}>
                <PhoneIcon sx={{ color: 'var(--sipzee-green)', fontSize: 30, alignSelf:'center' }} />
               
                    {isEdittingMyAccountProfile ?
                        <div style={{marginLeft:'10px'} }>
                            <div  style={{ marginTop: '7px' }}>
                                <TextField error={formValidation.errors['PhoneNumber'] !== undefined} label="Phone Number" onChange={(e) => setPhoneNumberChanged(e.target.value)} value={phoneNumber} variant="outlined" inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }} style={{ maxWidth: '270px' }} />
                                <div className='FormFieldErrorDescription' style={{ textAlign: 'left' }}> {formValidation.errors['PhoneNumber'] !== undefined ? formValidation.errors['PhoneNumber'] : ''}</div>
                            </div>
                        </div>
                        :
                        buildReadOnlyPhoneNumber()
                        
                    }
                   
                    
              
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <EmailIcon sx={{ color: 'var(--sipzee-green)', fontSize: 30 }} />
                <div style={{ marginRight: 'auto', marginLeft: 'auto', alignSelf: 'center' }}>{props.loggedInUser.EmailAddress}</div>
            </div>

            {props.loggedInUser.PhotoIdUrl == '' ?
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <ContactEmergencyIcon sx={{ color: 'var(--sipzee-yellow)', fontSize: 30, alignSelf:'center' }} />
                    <div style={{ marginRight: 'auto', marginLeft: 'auto', alignSelf: 'center' }}>
                        <div>Add a photo of a Govt Issued ID  <IconButton variant="contained" component="label">
                            <AddAPhotoIcon sx={{ fontSize: 40 }} />
                            <input hidden accept="image/*" type="file" onChange={(e) => handleUploadImageClick(e, 'PhotoId')} />
                        </IconButton></div>
                    </div>
                </div>
            :
            null
            
            }
        

            <div>

                {isEdittingMyAccountProfile ?
                    <div style={{ display: 'flex', justifyContent: 'space-between' }} >
                        <Fab onClick={() => setIsEditting(false)}>
                            <DoDisturbIcon sx={{ color: 'var(--sipzee-red)', fontSize: 30 }}  />
                        </Fab>
                        <Fab onClick={handleSaveProfile}>
                            <SaveIcon sx={{ color: 'var(--sipzee-gray)', fontSize: 30 }} ></SaveIcon>
                        </Fab>
                    </div>
                    :
                    <Fab onClick={() => setIsEditting(true)}>
                        <EditIcon sx={{ color: 'var(--sipzee-gray)', fontSize: 30 }} />
                    </Fab>
                }


            </div>

        </Stack>
    }

    return (<>
        <Card sx={{ minWidth: 300, maxWidth: 400, width:'95%', alignSelf: 'center', margin:'10px' }}>
            <CardContent>
                {props.loggedInUser == null ? buildSkeleton() : buildContent()}
            </CardContent>
        </Card>
        {isVerifyingPhoneNumber ? <VerifyPhoneNumber Close={(isVerified) => handleVerifyClosed(isVerified)} PhoneNumber={props.loggedInUser.PhoneNumber} /> : null}
        </>
    );
}
export default Profile;